import merge from 'deepmerge';

import authentication from '../modules/authentication/i18n/commonAuthentication';
import campaign from '../modules/campaign/i18n/commonCampaign';
import register from '../modules/registration/i18n/commonRegistration';
import commonSales from '../modules/sales/i18n/commonSales';
import commonNotifs from '../modules/ui/i18n/commonNotifs';

const translations = {
  fr: {
    common: {
      switchLanguage: 'English',
      date: {
        text: '{{value, LL}}',
        monthAndYear: '{{value, MMMM YYYY}}',
        standard: '{{value, DD/MM/YYYY}}',
        dateRange: 'du {{from, DD MMMM YYYY}} au {{to, DD MMMM YYYY}}',
        dayMonthShort: '{{value, DD MMM}}',
        dateRangeShortMonth: '{{from, DD MMM YYYY}}{{separator}}{{to, DD MMM YYYY}}',
      },
      dateFormat: {
        standard: 'DD/MM/YYYY',
      },
      number: {
        currency: '{{value, 0,0.00 $}}',
        fullCurrency: '{{value, 0,0 $}}',
        percentage: '{{value, 0.[0] %}}',
      },
      fullName: '{{firstName}} {{lastName}}',
      reach: 'Portée',
      averageReach: 'Portée moyenne',
      ageRange: 'Tranche d\'âge',
      demography: 'Démographie',
      geolocation: 'Géolocalisation',
      totalReach: 'Portée totale',
      weeklyReach: 'Portée par semaine',
      cumulativeImpressions: 'Impressions cumulatives',
      reachByDay: 'Portée par jour',
      listeningTime: 'Temps d\'écoute',
      averageByListener: 'Moyenne par auditeur',
      averageQuarterHour: 'Moyenne aux quarts d\'heures',
      averageQuarterHourV2: 'Moy. aux quarts d\'heures',
      impressions: 'Impressions',
      averageFrequency: 'Fréquence moyenne',
      costPerThousand: 'Coût par mille',
      numberOfOpportunities: 'Nombre d\'occasions',
      peopleReached: 'Personnes atteintes',
      days: 'Jours',
      dayOfWeek: {
        monday: 'Lundi',
        tuesday: 'Mardi',
        wednesday: 'Mercredi',
        thursday: 'Jeudi',
        friday: 'Vendredi',
        saturday: 'Samedi',
        sunday: 'Dimanche',
        short: {
          monday: 'Lun',
          tuesday: 'Mar',
          wednesday: 'Mer',
          thursday: 'Jeu',
          friday: 'Ven',
          saturday: 'Sam',
          sunday: 'Dim',
        },
      },
      week: 'Semaine',
      weekend: 'Fin de semaine',
      weekendSuffix: '(S-D)',
      weekDays: 'Jours de semaine',
      weekDaysSuffix: '(L-V)',
      singleDay: 'Jour unique',
      none: 'Aucun',
      all: 'Tous',
      allWeek: 'Semaine complète',
      allWeekSuffix: '(L-D)',
      specifiedPeriod: 'Période déterminée',
      selectedValues: '{{count}} valeur sélectionnée',
      selectedValues_plural: '{{count}} valeurs sélectionnées',
      cancel: 'Annuler',
      confirm: 'Confirmer',
      logIn: 'Connexion',
      signOut: 'Déconnexion',
      noDataAvailable: 'Pas de donnée disponible',
      na: 'N/A',
      time: {
        hours: 'Heures',
        hoursSymbol: 'h.',
        minutes: 'Minutes',
        nbMinute: '{{count}} minute',
        nbMinute_plural: '{{count}} minutes',
        nbHour: '{{count}} heure',
        nbHour_plural: '{{count}} heures',
        fromTo: 'de {{from, HH:mm}} à {{to, HH:mm}}',
      },
      increase: 'Gain',
      decrease: 'Perte',
      lastNbDays: 'Dernier jour',
      lastNbDays_plural: '{{count}} derniers jours',
      percentage: 'Pourcentage',
      gender: {
        name: 'Genres',
        men: 'Hommes',
        women: 'Femmes',
      },
      ok: 'Ok',
      apply: 'Appliquer',
      print: 'Imprimer',
      total: 'Total',
      choose: 'Choisir',
      cost: 'Coût',
      totalCost: 'Coût total',
      weeklyCost: 'Coût par semaine',
      start: 'Début',
      end: 'Fin',
      summary: 'Résumé',
      calculate: 'Calculer',
      email: 'Courriel',
      close: 'Fermer',
      add: 'Ajouter',
      yes: 'Oui',
      no: 'Non',
      save: 'Sauvegarder',
      search: 'Rechercher',
      searchDotted: 'Rechercher...',
      noResult: 'Aucun résultat',
      name: 'Nom',
      confirmationPrompt: 'Voulez-vous vraiment {{action, lowercase}}?',
      notifications: 'Notifications',
      noNotifications: 'Aucune nouvelle notification',
      customer: 'Client',
      allCampaigns: 'Toutes les campagnes',
      campaign: 'Campagne',
      radioConfigurationProgression: 'Progression de la configuration',
      salesman: 'Vendeur',
      you: 'Vous',
      send: 'Envoyer',
      delete: 'Supprimer',
      insufficientData: 'Données insuffisantes',
      lackOfSampling: 'Manque d\'échantillonnage',
      create: 'Créer',
      requiredField: 'Ce champ est requis',
      description: 'Description',
      modify: 'Modifier',
      enterDescriptionHere: 'Entrez la description ici',
      beta: 'beta',
      finish: 'Terminer',
      a25to54: 'T25-54',
      a35plus: 'T35+',
      spotsTitle: 'Spots',
      spots: '{{count}} spot',
      spots_plural: '{{count}} spots',
      personsSymbol: 'pers.',
      slogan: 'Intelligence d\'affaires pour radiodiffuseurs',
      market: 'Marché',
      fullMarket: 'Full',
    },
  },
  en: {
    common: {
      switchLanguage: 'Français',
      date: {
        text: '{{value, LL}}',
        monthAndYear: '{{value, MMMM YYYY}}',
        standard: '{{value, YYYY/MM/DD}}',
        dateRange: 'from {{from, MMMM DD, YYYY}} to {{to, MMMM DD, YYYY}}',
        dayMonthShort: '{{value, MMM DD}}',
        dateRangeShortMonth: '{{from, MMM DD, YYYY}}{{separator}}{{to, MMM DD, YYYY}}',
      },
      dateFormat: {
        standard: 'YYYY/MM/DD',
      },
      number: {
        currency: '{{value, $ 0,0.00}}',
        fullCurrency: '{{value, $ 0,0}}',
        percentage: '{{value, 0.[0] %}}',
      },
      fullName: '{{firstName}} {{lastName}}',
      reach: 'Reach',
      averageReach: 'Average reach',
      ageRange: 'Age Range',
      demography: 'Demography',
      geolocation: 'Geolocation',
      totalReach: 'Total reach',
      weeklyReach: 'Weekly reach',
      cumulativeImpressions: 'Cumulative Impressions',
      reachByDay: 'Reach by day',
      listeningTime: 'Listening Time',
      averageByListener: 'Average by Listener',
      averageQuarterHour: 'Average Quarter-Hour',
      averageQuarterHourV2: 'Average Quarter-Hour',
      impressions: 'Impressions',
      averageFrequency: 'Average Frequency',
      costPerThousand: 'Cost per Thousand',
      numberOfOpportunities: 'Number of Spots',
      peopleReached: 'People reached',
      days: 'Days',
      dayOfWeek: {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday',
        short: {
          monday: 'Mon',
          tuesday: 'Tue',
          wednesday: 'Wed',
          thursday: 'Thu',
          friday: 'Fri',
          saturday: 'Sat',
          sunday: 'Sun',
        },
      },
      week: 'Week',
      weekend: 'Weekend',
      weekendSuffix: '(S-S)',
      weekDays: 'Week days',
      weekDaysSuffix: '(M-F)',
      singleDay: 'Single day',
      none: 'None',
      all: 'All',
      allWeek: 'Entire Week',
      specifiedPeriod: 'Specified period',
      allWeekSuffix: '(M-S)',
      selectedValues: '{{count}} selected value',
      selectedValues_plural: '{{count}} selected values',
      cancel: 'Cancel',
      confirm: 'Confirm',
      logIn: 'Log in',
      signOut: 'Sign out',
      noDataAvailable: 'No data available',
      na: 'N/A',
      time: {
        hours: 'Hours',
        hoursSymbol: 'h.',
        minutes: 'Minutes',
        nbMinute: '{{count}} minute',
        nbMinute_plural: '{{count}} minutes',
        nbHour: '{{count}} hour',
        nbHour_plural: '{{count}} hours',
        fromTo: 'from {{from, HH:mm}} to {{to, HH:mm}}',
      },
      increase: 'Increase',
      decrease: 'Decrease',
      lastNbDays: 'Last day',
      lastNbDays_plural: 'Last {{count}} days',
      percentage: 'Percentage',
      gender: {
        name: 'Genders',
        men: 'Men',
        women: 'Women',
      },
      ok: 'Ok',
      apply: 'Apply',
      print: 'Print',
      total: 'Total',
      choose: 'Choose',
      cost: 'Cost',
      totalCost: 'Total Cost',
      weeklyCost: 'Weekly Cost',
      start: 'Start',
      end: 'End',
      summary: 'Summary',
      calculate: 'Calculate',
      email: 'Email',
      close: 'Close',
      add: 'Add',
      yes: 'Yes',
      no: 'No',
      save: 'Save',
      search: 'Search',
      searchDotted: 'Search...',
      noResult: 'No result',
      name: 'Name',
      confirmationPrompt: 'Are you sure you want to {{action, lowercase}}?',
      notifications: 'Notifications',
      noNotifications: 'No new notifications',
      customer: 'Customer',
      allCampaigns: 'All campaigns',
      campaign: 'Campaign',
      radioConfigurationProgression: 'Radio configuration progress',
      salesman: 'Salesman',
      you: 'You',
      delete: 'Delete',
      send: 'Send',
      insufficientData: 'Insufficient data',
      lackOfSampling: 'Lack of sampling',
      create: 'Create',
      requiredField: 'This field is required',
      description: 'Description',
      modify: 'Edit',
      enterDescriptionHere: 'Enter the description here',
      beta: 'beta',
      finish: 'Finish',
      a25to54: 'A25-54',
      a35plus: 'A35+',
      spotsTitle: 'Spots',
      spots: '{{count}} spot',
      spots_plural: '{{count}} spots',
      personsSymbol: 'pers.',
      slogan: 'Business intelligence for radio broadcasters',
      market: 'Market',
      fullMarket: 'Full',
    },
  },
};

export default merge.all([
  authentication,
  campaign,
  commonSales,
  commonNotifs,
  register,
  translations,
]);



// WEBPACK FOOTER //
// ./src/common/i18n/common.js